import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { GeneralChartModule } from 'ChartApp/ts/features/general-chart/general-chart.module';
import { PerformanceChartModule } from 'ChartApp/ts/features/performance-chart/performance-chart.module';
import { ComparablesModalButtonModule } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.module';
import { PerformanceIncludeBenchmarkCheckboxModule } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'Angular/features/components/side-menu/side-menu.component';
import { GeneralChartComponent } from 'ChartApp/ts/features/general-chart/components/general-chart/general-chart.component';
import { GeneralChartResponsiveComponent } from 'ChartApp/ts/features/general-chart/components/general-chart-responsive/general-chart-responsive.component';
import { PerformanceChartComponent } from 'ChartApp/ts/features/performance-chart/performance-chart.component';
import { ComparablesModalButtonComponent } from 'SecuritiesApp/ts/features/comparables-modal-button/comparables-modal-button.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'Angular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import { PerformanceIncludeBenchmarkCheckboxComponent } from 'SecuritiesApp/ts/features/performance-include-benchmark-checkbox/performance-include-benchmark-checkbox';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    ComparablesModalButtonComponent,
    GeneralChartComponent,
    GeneralChartResponsiveComponent,
    PerformanceIncludeBenchmarkCheckboxComponent,
    SideMenuComponent,
    SecurityHeaderControlComponent,
    TopBarNavComponent,
];
export class MutualFundsPerformanceBetaModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [
            GeneralChartComponent,
            GeneralChartResponsiveComponent,
            PerformanceChartComponent,
        ];
    }
}
MutualFundsPerformanceBetaModule.ɵfac = function MutualFundsPerformanceBetaModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MutualFundsPerformanceBetaModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
MutualFundsPerformanceBetaModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: MutualFundsPerformanceBetaModule });
MutualFundsPerformanceBetaModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ComparablesModalButtonModule,
        ConfigModule,
        CommonModule,
        FormsModule,
        GeneralChartModule,
        NavigationModule,
        PerformanceChartModule,
        PerformanceIncludeBenchmarkCheckboxModule,
        SecurityHeaderControlModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
